import { Page } from "~/api/model/page";

export const updateDocListSectionPage =
  (sectionId: string, pageId: string, data: Partial<Page>) =>
  (oldData: any) => {
    if (!oldData) return oldData;

    const updatedTree = oldData.tree.map((doc: any) => ({
      ...doc,
      sections: doc.sections.map((section: any) => {
        if (section.id !== sectionId) return section;

        return {
          ...section,
          pages: (section.pages || []).map((p: any) => {
            if (p.id !== pageId) return p;

            return {
              ...p,
              ...data,
            };
          }),
        };
      }),
    }));

    return {
      ...oldData,
      tree: updatedTree,
    };
  };
